
import React from 'react';
import { CheckboxInput, useFilterContext } from 'ui-builder';
import { WebhookSubscriptionsFilter } from 'nekst-api';

export default function OnlyManuallyCreatedFilter() {

  const filterContext = useFilterContext<WebhookSubscriptionsFilter>();

  return (
    <CheckboxInput
      source="onlyManuallyCreatedFilter"
      value={!!filterContext.filterValue?.onlyManuallyCreated}
      label="Show manually created webhooks only"
      onChangeCallback={() => {
        filterContext.setFilterValue({
          ...filterContext.filterValue || {},
          onlyManuallyCreated: !filterContext.filterValue?.onlyManuallyCreated,
        })
      }}
    />
  );
}
